// The wallet statement's period picker. Days are São Paulo days (fixed UTC-3,
// as on the backend).
const SAO_PAULO_OFFSET_MS = 3 * 60 * 60 * 1000;

export type StatementPeriod = {
  key: string;
  from: string | null;
  to: string | null;
  month: string | null;
};

const pad = (value: number) => String(value).padStart(2, '0');

export function saoPauloDayKey(now: Date): string {
  return new Date(now.getTime() - SAO_PAULO_OFFSET_MS).toISOString().slice(0, 10);
}

export function buildStatementPeriods(now: Date, monthCount = 12): StatementPeriod[] {
  const [year, month] = saoPauloDayKey(now).split('-').map(Number);
  const periods: StatementPeriod[] = [{ key: 'last30', from: null, to: null, month: null }];
  for (let offset = 0; offset < monthCount; offset += 1) {
    const first = new Date(Date.UTC(year, month - 1 - offset, 1));
    const y = first.getUTCFullYear();
    const m = first.getUTCMonth() + 1;
    const lastDay = new Date(Date.UTC(y, m, 0)).getUTCDate();
    const key = `${y}-${pad(m)}`;
    periods.push({ key, from: `${key}-01`, to: `${key}-${pad(lastDay)}`, month: key });
  }
  return periods;
}

export function formatPeriodMonth(month: string, locale: string): string {
  const [y, m] = month.split('-').map(Number);
  return new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric', timeZone: 'UTC' })
    .format(new Date(Date.UTC(y, m - 1, 15)));
}
